import React from 'react';

import DuraCraftLogo from './images/DuraCraftLogo.svg';
import LuxLogo from './images/LuxLogo.svg';
import PfisterLogo from './images/PfisterLogo.svg';
import KwiksetLogo from './images/KwiksetLogo.svg';
import FrigidareLogo from './images/FrigidareLogo.svg';
import RheemLogo from './images/RheemLogo.svg';
import SamsungLogo from './images/SamsungLogo.svg';
import ShawLogo from './images/ShawLogo.svg';
import CarrierLogo from './images/CarrierLogo.svg';
import EcobeeLogo from './images/EcobeeLogo.svg';

const logoItems = [
  /* eslint-disable react/jsx-key */
  <DuraCraftLogo viewBox="0 0 131 31" />,
  <LuxLogo viewBox="0 0 85 61" />,
  <PfisterLogo viewBox="0 0 110 27" />,
  <KwiksetLogo viewBox="0 0 124 19" />,
  <FrigidareLogo viewBox="0 0 135 17" />,
  <RheemLogo viewBox="0 0 63 63" />,
  <SamsungLogo viewBox="0 0 143 23" />,
  <ShawLogo viewBox="0 0 126 45" />,
  <CarrierLogo viewBox="0 0 126 53" />,
  <EcobeeLogo viewBox="0 0 143 29" />,
  /* eslint-enable react/jsx-key */
];

const LogoLake = () => {
  // Need a double set of items for the scroller for continuous scroll.
  const getScrollerContent = (items) => {
    // set aria-hidden on second set of logos
    const dupItems = Array.from(items, (e) => ({
      ...e,
      props: { ...e.props, 'aria-hidden': 'true' },
    }));
    const dblItems = items.concat(dupItems);

    // add a key value for all logo items
    const scrollItems = dblItems.map((e, i) => ({
      ...e,
      key: 'logo-' + `${i + 1}`,
    }));
    return scrollItems;
  };

  return (
    <div className="mt-[72px] tablet:mt-[96px]">
      <div className="constrained-width">
        <h3 className="logo-lake-heading mb-2 tablet:text-center">
          Our Brand Partners
        </h3>
        <p className="logo-lake-text tablet:text-center">
          Clayton partners with many top home building brands, so you know your
          home includes quality, innovative and durable products you can enjoy
          for the years to come.
        </p>
      </div>
      <div className="scroller mx-auto my-0 max-w-full overflow-hidden 2xl:max-w-[1620px] 2xl:[mask:_linear-gradient(90deg,transparent,white_10%,white_90%,transparent)]">
        {/* Note: The width specified for gap-[] relates to the value in the 'logoscroll' keyframe (in theme.js). 'logoscroll' needs half of the value set by gap. */}
        <div className="scroller__inner flex h-[111px] w-max animate-[logoscroll_30s_forwards_linear_infinite] flex-nowrap items-center gap-[48px]">
          {getScrollerContent(logoItems)}
        </div>
      </div>
    </div>
  );
};

export default LogoLake;
